"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.windowsHighContrastTickStyle = exports.windowsHighContrastDisableStyle = void 0;

var _utils = require("../../utils");

var _constants = require("../constants");

var windowsHighContrastDisableStyle = function windowsHighContrastDisableStyle() {
  return {
    '.detailedCheckboxTick': {
      backgroundColor: _constants.WHCM_DISABLED_ITEM_COLOR,
      borderColor: _constants.WHCM_DISABLED_ITEM_COLOR
    },
    border: "solid ".concat((0, _utils.px)(_constants.CHECKBOX_BORDER_WIDTH), " ").concat(_constants.WHCM_DISABLED_ITEM_COLOR),
    'input:checked ~ &': {
      '.tick': {
        stroke: _constants.WHCM_ITEM_COLOR,
        strokeDasharray: '15, 20000',
        opacity: 1
      }
    }
  };
};

exports.windowsHighContrastDisableStyle = windowsHighContrastDisableStyle;

var windowsHighContrastTickStyle = function windowsHighContrastTickStyle() {
  return {
    '.detailedCheckboxTick': {
      '.tick': {
        stroke: _constants.WHCM_ITEM_COLOR,
        strokeDasharray: '15, 20000',
        opacity: 1
      }
    }
  };
};

exports.windowsHighContrastTickStyle = windowsHighContrastTickStyle;